export const shipping = {
  free_threshold_grams: 9999000,
  low_threshold_grams: 999000,
  free_threshold_pence: 4000,
}
